module.exports = "/images/Jordan.png?856f1d9157aa470a2fc48b3aa1a13218";